import { Label } from "@/components/ui/label";
import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation } from "react-i18next";
import { useRecordViewContext } from "./RecordContext";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface RecordFieldProps {
  name: string;
  label?: ReactNode;
  className?: string;
  renderer?: (value: string) => React.ReactElement | string;
  icon?: ReactNode;
}

interface ValueRendererProps {
  value: string;
  renderer?: (value: string) => React.ReactElement | string;
  icon?: ReactNode;
}

const ValueRenderer = ({ value, renderer, icon }: ValueRendererProps) => {
  if (renderer) {
    return renderer(value);
  }
  return (
    <span className="flex flex-row gap-1 items-center text-muted-foreground">
      {icon}
      {value}
    </span>
  );
};

const RecordField = ({
  name,
  renderer,
  className,
  label,
  icon,
}: RecordFieldProps) => {
  const { t } = useTranslation();
  const { translationKey, query } = useRecordViewContext();
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <Label className="text-sm font-medium">
        {label || t(`${translationKey}.fields.${name}`)}
      </Label>
      <span className="text-sm text-muted-foreground">
        {query.isLoading ? (
          <Skeleton className="w-full h-4" />
        ) : (
          <ValueRenderer
            value={query.data?.[name] as string}
            renderer={renderer}
            icon={icon}
          />
        )}
      </span>
    </div>
  );
};

export default RecordField;
